<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (click)="windowClick()">
  <dialog-header [label]="'Cameras In Analysis (' + cameras.length + ')'" [dialogRef]='dialogRef' (mousedown)="windowClick()" [object]='this'>
  </dialog-header>
  <div class="scroll-container">
    <div *ngIf="cameras.length == 0">
      Error Retrieving Cameras in Analysis List
    </div>

    <div *ngFor="let ent of cameras" class="row">
      <div class="cell channel">
        <div>{{ ent.cameraStreamName.split('.')[0] }}</div>
      </div>
      <div class="cell camera-info">
        <div>{{ ent.cameraName }}</div>
      </div>
      <div class="cell buttons">
        <button class="small-button" mat-stroked-button (click)="setCenter(ent.cameraStreamName)"
          [matTooltip]="'Center Camera'">
          <mat-icon class="svg-icon">place</mat-icon>
        </button>
        <button class="small-button" mat-stroked-button (click)="openAro(ent.cameraStreamName)"
          [matTooltip]="'Open Camera ARO'">
          <mat-icon class="svg-icon">assignment</mat-icon>
        </button>
        <button class="small-button" mat-stroked-button (click)="removeCamera(ent.cameraStreamName)"
          [matTooltip]="'Remove'">
          <mat-icon class="svg-icon">delete</mat-icon>
        </button>
        <mat-icon class="svg-icon" [matTooltip]="'Set by: ' + ent.lastUpdateUser + ' At: ' + ent.lastUpdateDate"
          style="align-self: center">info</mat-icon>
      </div>
    </div>
  </div>
</div>